import ErrorMessage from '@/components/common/error-message/ErrorMessage';
import GoBack from '@/components/common/go-back/GoBack';
import NoData from '@/components/common/no-data/NoData';
import FormInventory from '@/components/forms/form-inventory/FormInventory';
import { Skeleton } from '@/components/ui/skeleton';
import useEditInventory from '@/hooks/pages/useEditInventory';

const EditInventory = () => {
  const {
    isError,
    isLoading,
    equipmentItem,
    inventoryCategories,
    onSubmit,
    defaultValues,
    isPending
  } = useEditInventory();

  if (isLoading) {
    return (
      <>
        <GoBack />
        <Skeleton className="w-full h-[332px]" />
      </>
    );
  }

  if (!equipmentItem || !inventoryCategories) {
    return (
      <>
        <GoBack />
        <NoData />
      </>
    );
  }

  if (isError) {
    return (
      <>
        <GoBack />
        <ErrorMessage />
      </>
    );
  }

  return (
    <>
      <GoBack />
      <div className="flex justify-center w-full">
        <FormInventory
          onSubmit={onSubmit}
          isPending={isPending}
          defaultValues={defaultValues}
          inventoryCategories={inventoryCategories}
        />
      </div>
    </>
  );
};

export default EditInventory;
